import { render, staticRenderFns } from "./AdminOverviewCharts.vue?vue&type=template&id=bccb051c"
import script from "./AdminOverviewCharts.vue?vue&type=script&lang=js"
export * from "./AdminOverviewCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports